module.exports = __webpack_public_path__ + "media/images/icon-con-c630d1fa8b1a1cda4b4d3f946e245e51.svg";